import { PersonTypeEnum } from '@zaoblako/shared/modules/client/enums/person.type.enum';
import { PersonPassportDataDto, type PersonPassportDataInterface } from '@zaoblako/shared/modules/client/dtos/person/person-passport-data.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';

import * as yup from 'yup';

/** Common person (company or counterparty) response body */
export interface PersonFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Is company soft deleted */
  deleted?: Date;
  /** Display name */
  name: string;
  /** Taxpayer Identification Number (INN, rus. "ИНН") */
  inn?: string;
  /** Primary State Registration Number (OGRN, rus. "ОГРН") */
  ogrn: string;
  /** Taxpayer Registration Reason Code (KPP, rus. "КПП") */
  kpp: string;
  /** Primary State Registration Number for Individual Entrepreneur (OGRNIP, rus. "ОГРНИП") */
  ogrnip: string;
  /** Manager name */
  manager: string;
  /** Main phone number */
  phone?: string;
  /** Person web site address */
  website?: string;
  /** Person main email address */
  email?: string;
  /** Person geographic address */
  address?: string;
  /** Person real mail address */
  postAddress?: string;
  /** Person type */
  personType: PersonTypeEnum;
  /** Manager passport data */
  passport: PersonPassportDataInterface;
}

/** Common person (company or counterparty) response body - DTO schema */
export const PersonFindDto = SerdeDtoClass.create<PersonFindInterface>(ClientDtoKeysEnum.PERSON_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  deleted: {
    sortable: true,
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  inn: {
    sortable: true,
    label: 'ИНН',
    serializer: yup.string(),
  },
  ogrn: {
    sortable: true,
    label: 'ОГРН',
    serializer: yup.string(),
  },
  kpp: {
    sortable: true,
    label: 'КПП',
    serializer: yup.string(),
  },
  ogrnip: {
    label: 'ОГРНИП',
    serializer: yup.string(),
  },
  manager: {
    sortable: true,
    label: 'Менеджер',
    serializer: yup.string(),
  },
  phone: {
    sortable: true,
    optional: true,
    label: 'Телефон',
    serializer: yup.string(),
  },
  website: {
    sortable: true,
    optional: true,
    label: 'Веб-сайт',
    serializer: yup.string(),
  },
  email: {
    sortable: true,
    optional: true,
    label: 'Email',
    serializer: yup.string(),
  },
  address: {
    sortable: true,
    optional: true,
    label: 'Адрес',
    serializer: yup.string(),
  },
  postAddress: {
    sortable: true,
    optional: true,
    label: 'Почтовый адрес',
    serializer: yup.string(),
  },
  personType: {
    sortable: true,
    label: 'Тип',
    serializer: yup
      .string()
      .oneOf(Object.values(PersonTypeEnum)),
  },
  passport: {
    sortable: true,
    nested: PersonPassportDataDto,
    label: 'Паспортные данные',
    serializer: (_, nested) => nested,
  },
});
